module.exports = __webpack_public_path__ + "static/Pt10-5133c2e37bcc063dff5c533e461b5685.jpg";